import { create } from "zustand";
import type { User } from "@/services/userApi";

interface UserUIState {
  searchTerm: string;
  isFormOpen: boolean;
  selectedUser: User | null;
  formLoading: boolean;
  setSearchTerm: (value: string) => void;
  openCreateForm: () => void;
  openEditForm: (user: User) => void;
  closeForm: () => void;
  setFormLoading: (value: boolean) => void;
}

export const useUserUIStore = create<UserUIState>((set) => ({
  searchTerm: "",
  isFormOpen: false,
  selectedUser: null,
  formLoading: false,
  setSearchTerm: (value) => set({ searchTerm: value }),
  openCreateForm: () => set({ isFormOpen: true, selectedUser: null }),
  openEditForm: (user) => set({ isFormOpen: true, selectedUser: user }),
  closeForm: () => set({ isFormOpen: false, selectedUser: null }),
  setFormLoading: (value) => set({ formLoading: value }),
}));
